export default "__VITE_ASSET__5af29af4__"